import React, { useContext } from "react";
import { Grid, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MyButton } from "../../components/my-button/MyButton";
import { Circle } from "../../components/Circle";
import MyContext from "../../contexts/MyContext";
export const FormWrapper = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const onBack = () => {
    myContext.changeActiveSlide((myContext.activeSlide -= 1));
  };
  return (
    <Grid container style={{ padding: "1rem" }}>
      <Box className="evf heading" component="h1" color="primary.main" style={{ marginTop: "0", marginBottom: "1rem", marginLeft: "0" }}>
        {t("apply_for_reimbursement")}
      </Box>
      <Grid container item xs={12} sm={12} alignItems="center" wrap="nowrap" style={{ marginBottom: "0.5rem" }}>
        <Circle>{props.number}</Circle>
        <p style={{ marginTop: "0", marginBottom: "0", marginLeft: "1rem", wordBreak: "break-all" }}>{props.heading}</p>
      </Grid>
      <p id="required-description" className="margin bottom-0">
        <Box component="small" color="error.main">
          *
        </Box>
        <small> {t("required_field")}</small>
      </p>
      <Grid container item xs={12} sm={12} justifyContent="center">
        {props.children}
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
        {(props.hasBackButton == null || props.hasBackButton !== false) && (
          <Grid item>
            <MyButton className="button primary" text={props.backButtonLabel ?? t("back")} color="default" onClick={onBack} buttonVariant="outlined" />
          </Grid>
        )}
        {(props.hasContinueButton == null || props.hasContinueButton !== false) && (
          <Grid item>
            <MyButton className="button primary" text={props.continueButtonLabel ?? t("continue")} onClick={props.onContinue} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
